import { purify } from "../../_src/components/purify";

export function searchMetodologias() {
    var btnLoadMore = document.querySelector("[data-action=load-more]")

    function search(loadMore) {
        btnLoadMore.classList.add("loading")

        fetch(`/ifag/metodologias/ajax/metodologias.html/p${btnLoadMore.getAttribute("data-page")}`)
        .then((response) => {
            return response.text();
        }).then((response) => {
            if (loadMore) {
                document.querySelector("#result-methodologies").insertAdjacentHTML('beforeend', response);
            } else {
                document.querySelector("#result-methodologies").innerHTML = purify(response);
            }
        })
        .catch((error) => {
            console.error(error);
        })
        .finally(() => {
            btnLoadMore.classList.remove("loading")

            if (parseInt(btnLoadMore.dataset.page) > parseInt(btnLoadMore.dataset.total)) {
                btnLoadMore.classList.add('hidden');
            }
        });
    }

    btnLoadMore.addEventListener("click", function() { search(true), btnLoadMore.dataset.page = parseInt(btnLoadMore.dataset.page) + 1 }, false);
}

if (document.querySelector("#result-methodologies")) {
    searchMetodologias();
}
